var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { getActivePromo, formatEUR, formatPromoDate } from '../utils/promo';
import PromoFields, { promoFormFromProduct, validatePromoForm, confirmLongPromo, appendPromoToFormData, defaultPromoEndDate } from './PromoFields';
var getStatus = function (product) {
    if (getActivePromo(product))
        return 'active';
    if (product.promoPriceEUR || product.promoEndsAt)
        return 'expired';
    return 'none';
};
var STATUS_ORDER = { active: 0, expired: 1, none: 2 };
var PromotionsManager = function (_a) {
    var products = _a.products, loading = _a.loading, onSaved = _a.onSaved, onError = _a.onError;
    var _b = useState(null), editingId = _b[0], setEditingId = _b[1];
    var _c = useState(null), form = _c[0], setForm = _c[1];
    var _d = useState(null), savingId = _d[0], setSavingId = _d[1];
    var _e = useState('all'), filter = _e[0], setFilter = _e[1];
    var sorted = __spreadArray([], products, true).filter(function (p) { return filter === 'all' || getStatus(p) === 'active'; })
        .sort(function (a, b) { return STATUS_ORDER[getStatus(a)] - STATUS_ORDER[getStatus(b)]; });
    var activeCount = products.filter(function (p) { return getStatus(p) === 'active'; }).length;
    var startEditing = function (product) {
        var existing = promoFormFromProduct(product);
        setForm(existing.enabled ? existing : __assign(__assign({}, existing), { enabled: true, endDate: defaultPromoEndDate() }));
        setEditingId(product.id);
        onError('');
    };
    var cancelEditing = function () {
        setEditingId(null);
        setForm(null);
    };
    var savePromo = function (product, promo) { return __awaiter(void 0, void 0, void 0, function () {
        var validationError, token, body, response, data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    validationError = validatePromoForm(promo, product.priceEUR);
                    if (validationError) {
                        onError(validationError);
                        return [2 /*return*/];
                    }
                    if (!confirmLongPromo(promo))
                        return [2 /*return*/];
                    token = localStorage.getItem('redaktor_token');
                    if (!token) {
                        onError('Authentication required. Please log in again.');
                        return [2 /*return*/];
                    }
                    body = new FormData();
                    body.append('priceEUR', product.priceEUR.toString());
                    appendPromoToFormData(body, promo);
                    setSavingId(product.id);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    return [4 /*yield*/, fetch("/api/products/".concat(product.id), {
                            method: 'PUT',
                            headers: { 'Authorization': "Bearer ".concat(token) },
                            body: body
                        })];
                case 2:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json().catch(function () { return ({}); })];
                case 3:
                    data = _b.sent();
                    onError(data.message || 'Failed to save promotion');
                    return [2 /*return*/];
                case 4:
                    cancelEditing();
                    return [4 /*yield*/, onSaved(promo.enabled
                            ? "Promotion saved for \"".concat(product.nameBg || product.name, "\"")
                            : "Promotion removed from \"".concat(product.nameBg || product.name, "\""))];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 8];
                case 6:
                    _a = _b.sent();
                    onError('Network error. Please try again.');
                    return [3 /*break*/, 8];
                case 7:
                    setSavingId(null);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var removePromo = function (product) {
        if (!window.confirm("Remove the promotion from \"".concat(product.nameBg || product.name, "\"?")))
            return;
        savePromo(product, { enabled: false, price: '', percent: '', endDate: '' });
    };
    if (loading && products.length === 0) {
        return _jsx("div", { className: "loading", children: "Loading products..." });
    }
    return (_jsxs("div", { className: "promotions-manager", children: [_jsxs("div", { className: "promotions-toolbar", children: [_jsx("h3", { children: "Manage Promotions" }), _jsxs("span", { className: "promotions-count", children: [activeCount, " active"] }), _jsxs("select", { value: filter, onChange: function (e) { return setFilter(e.target.value); }, children: [_jsx("option", { value: "all", children: "All wines" }), _jsx("option", { value: "active", children: "Only active promotions" })] })] }), sorted.length === 0 ? (_jsx("div", { className: "no-products", children: _jsx("p", { children: "No wines match this filter." }) })) : (_jsx("div", { className: "promotions-list", children: sorted.map(function (product) {
                    var status = getStatus(product);
                    var activePromo = getActivePromo(product);
                    var isEditing = editingId === product.id && form;
                    var isSaving = savingId === product.id;
                    return (_jsxs("div", { className: "promotion-row promotion-".concat(status), children: [_jsxs("div", { className: "promotion-summary", children: [_jsx("img", { src: product.imageUrl, alt: product.name, className: "promotion-thumb", onError: function (e) { e.target.src = '/api/products/default-image'; } }), _jsxs("div", { className: "promotion-info", children: [_jsx("h4", { children: product.nameBg || product.name }), _jsx("p", { className: "promotion-prices", children: activePromo ? (_jsxs(_Fragment, { children: [_jsx("s", { children: formatEUR(product.priceEUR) }), " ", _jsx("strong", { children: formatEUR(activePromo.price) })] })) : (_jsx("strong", { children: formatEUR(product.priceEUR) })) }), _jsxs("span", { className: "promotion-badge promotion-badge-".concat(status), children: [status === 'active' && activePromo && "-".concat(activePromo.percent, "% until ").concat(formatPromoDate(activePromo.endsAt)), status === 'expired' && "Expired".concat(product.promoEndsAt ? " on ".concat(formatPromoDate(new Date(product.promoEndsAt))) : ''), status === 'none' && 'No promotion'] })] }), !isEditing && (_jsxs("div", { className: "promotion-actions", children: [_jsx("button", { className: "edit-btn", onClick: function () { return startEditing(product); }, disabled: isSaving, children: status === 'active' ? 'Edit promo' : 'Set promo' }), status !== 'none' && (_jsx("button", { className: "delete-btn", onClick: function () { return removePromo(product); }, disabled: isSaving, children: isSaving ? 'Removing...' : 'Remove' }))] }))] }), isEditing && form && (_jsxs("div", { className: "promotion-editor", children: [_jsx(PromoFields, { regularPrice: product.priceEUR, value: form, onChange: setForm, showToggle: false, idPrefix: "promo-".concat(product.id) }), _jsxs("div", { className: "form-actions", children: [_jsx("button", { className: "submit-btn", onClick: function () { return savePromo(product, form); }, disabled: isSaving, children: isSaving ? 'Saving...' : 'Save promotion' }), _jsx("button", { className: "reset-btn", onClick: cancelEditing, disabled: isSaving, children: "Cancel" })] })] }))] }, product.id));
                }) }))] }));
};
export default PromotionsManager;
